import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { AudioAlertTracker, Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component
export default class HeaderShared extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("singlePatientView", patientNamespace)
  singlePatientView!: boolean;

  @Getter("helpStep", navigationNamespace)
  helpStep!: number;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("showStaff", patientNamespace)
  showStaff!: boolean;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("mobilePage", navigationNamespace)
  mobilePage!: number;

  @Getter("fullName", userNamespace)
  fullName!: string;

  @Getter("hasError", patientNamespace)
  hasError!: boolean;

  @Getter("audioAlerts", patientNamespace)
  audioAlerts!: Record<string, AudioAlertTracker>;

  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  get patientAudioAlerts() {
    const filteredResults: Record<string, AudioAlertTracker> = {};
    // No filter, just read them all
    Object.entries(this.audioAlerts).forEach(([key, tracker]) => {
      filteredResults[key] = tracker;
      tracker.message = tracker.alert.audioMessage;
      if (tracker.alert.level === 5) {
        tracker.repeatIntervalOverrideMinutes = 5;
      }
    });
    return filteredResults;
  }

  @Emit()
  back() {}
}
